exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./aws.icon.svg"));

// Module
exports.push([module.id, ".cloud-provider-logo .icon-aws {\n  -webkit-mask-image: url(" + ___CSS_LOADER_URL___0___ + ");\n          mask-image: url(" + ___CSS_LOADER_URL___0___ + ");\n}\n", ""]);

